module.exports = __webpack_public_path__ + "img/verification.1ab72aa6.svg";